import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import OInput from '../FormControls/OInput';
import MuiDialog from '../MuiDialog/MuiDialog';

const MultiSelectDialog = ({
  secondSelect,
  secondSelectName = '',
  data = [],
  selectedItems = [],
  secondSelectedItems = [],
  setSelectedItems,
  setSecondSelectedItems,
  setStringView,
  openDialog,
  handleClose,
  handleConfirm,
  title = 'Zaposleni',
  readProp = 'naziv',
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [dataArr, setDataArr] = useState([]);

  useEffect(() => {
    const newArrayOfObj = data.map(
      ({ [readProp]: vrednost, ...rest }, index) => ({
        id: index,
        vrednost,
        ...rest,
      }),
    );
    setDataArr(newArrayOfObj);
    setFilteredData(newArrayOfObj);
  }, [data]);

  useEffect(() => {
    setFilteredData(
      dataArr.filter((item) =>
        item?.vrednost?.toLowerCase().includes(searchValue.toLowerCase()),
      ),
    );
  }, [searchValue]);

  const handleClickItem = (selectedItem) => {
    const itemId = selectedItem.id;
    const isItemSelected = selectedItems.some((item) => item.id === itemId);
    let updatedSelectedItems = [];
    // sluzi samo da decekira drugi
    let updatedSecundSelectedItems = [];

    if (isItemSelected) {
      updatedSelectedItems = selectedItems.filter((item) => item.id !== itemId);
      if (secondSelect) {
        updatedSecundSelectedItems = secondSelectedItems.filter(
          (item) => item.id !== itemId,
        );
        setSecondSelectedItems(updatedSecundSelectedItems);
      }
    } else {
      updatedSelectedItems = [...selectedItems, selectedItem];
    }

    setSelectedItems(updatedSelectedItems);

    const selectedValues = updatedSelectedItems.map((item) => item.vrednost);
    const selectedValuesString = selectedValues.join(', ');
    // setStringView(selectedValuesString);
  };

  const handleClearAll = () => {
    setSelectedItems([]);
    // setStringView('');
  };
  const handleChangeKomisija = (e, selectedItem) => {
    e.stopPropagation();
    const itemId = selectedItem.id;
    const isItemSelected = secondSelectedItems.some(
      (item) => item.id === itemId,
    );
    let updatedSelectedItems = [];

    if (isItemSelected) {
      updatedSelectedItems = secondSelectedItems.filter(
        (item) => item.id !== itemId,
      );
    } else {
      updatedSelectedItems = [...secondSelectedItems, selectedItem];
    }

    setSecondSelectedItems(updatedSelectedItems);

    const selectedValues = updatedSelectedItems.map((item) => item.vrednost);
    const selectedValuesString = selectedValues.join(', ');
    // setStringView(selectedValuesString);
  };
  return (
    <MuiDialog
      maxWidth="xs"
      open={openDialog}
      content={
        <div style={{ position: 'relative' }}>
          <div
            style={{
              marginBottom: '10px',
            }}
          >
            <OInput
              label="Dodatna pretraga..."
              handleChange={(e) => setSearchValue(e.target.value)}
            />
          </div>

          {selectedItems.length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'end' }}>
              <Button
                variant="contained"
                onClick={handleClearAll}
                style={{
                  backgroundColor: '#cccccc', // Gray color
                  color: '#000', // Black text
                  padding: '4px 8px', // Smaller size
                  fontSize: '0.75rem', // Smaller font size
                  textTransform: 'none', // Keep text as normal case
                  boxShadow: 'none',
                }}
              >
                Poništi sve
              </Button>
            </div>
          )}
          <ul style={{ listStyle: 'none', padding: '0px' }}>
            <li
              style={{
                paddingBottom: '0px',
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: '1rem',
                borderBottom: '1px solid gray',
                marginBottom: '0px',
                fontWeight: '600',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              {title}
              {secondSelect && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span>{secondSelectName}</span>
                </div>
              )}
            </li>
            {filteredData.length === 0 ? (
              <p
                style={{
                  fontSize: '1rem',
                  textAlign: 'center',
                  fontWeight: '600',
                }}
              >
                Nema rezultata za prikaz.
              </p>
            ) : (
              filteredData.map((item) => (
                <li
                  key={item.id}
                  style={{
                    paddingBottom: '0px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: '1rem',
                    borderBottom: '1px solid gray',
                    marginBottom: '0px',
                    fontWeight: '600',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleClickItem(item)}
                >
                  <span>{item.vrednost}</span>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {item.brojNedovrsenihZadataka > 0 && (
                      <span
                        style={{
                          backgroundColor: 'red',
                          color: 'white',
                          padding: '2px 3px',
                          borderRadius: '12px',
                          marginRight: '25px',
                          fontSize: '0.8rem',
                          fontWeight: 'bold',
                          minWidth: '24px',
                          textAlign: 'center',
                        }}
                      >
                        {item.brojNedovrsenihZadataka}
                      </span>
                    )}
                    <Checkbox
                      sx={{ '& .MuiSvgIcon-root': { fontSize: '1.5rem' } }}
                      checked={selectedItems.some(
                        (selectedItem) => selectedItem.id === item.id,
                      )}
                      color="primary"
                    />
                    {secondSelect && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <Checkbox
                          sx={{
                            '& .MuiSvgIcon-root': {
                              fontSize: '1.5rem',
                              marginLeft: '10px',
                              marginRight: '10px',
                            },
                          }}
                          disabled={
                            !selectedItems.some(
                              (selectedItem) => selectedItem.id === item.id,
                            )
                          }
                          checked={secondSelectedItems.some(
                            (selectedItem) => selectedItem.id === item.id,
                          )}
                          color="primary"
                          onChange={(e) => handleChangeKomisija(e, item)}
                        />
                      </div>
                    )}
                  </div>
                </li>
              ))
            )}
          </ul>
        </div>
      }
      handleConfirm={handleConfirm}
      handleClose={handleClose}
      deniedText="ZATVORI"
    />
  );
};

MultiSelectDialog.propTypes = {
  data: PropTypes.array,
  selectedItems: PropTypes.array,
  setSelectedItems: PropTypes.func,
  // setStringView: PropTypes.func,
};

export default MultiSelectDialog;
